
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 import { SkyImage as SkyImageElement } from '@sky.ui/core/sky-image';
 
 
 
 

 
 export const SkyImage = createComponent({
   displayName: 'SkyImage',
   react: React,
   tagName: 'sky-image',
   elementClass: SkyImageElement,
   events: {
     
   }
  });
export type * from '@sky.ui/core/sky-image';
